<div *ngIf="carrierFeedbackList.length > 0" class="container">
	<div>
		<h3 class="primary-text">Recent Activity</h3>
		<table style="width: 100%; border: 1px solid #a9a9a9">
			<tr *ngFor="let carrierFeedback of carrierFeedbackList | slice: 0:getSize()">
				<div
					(click)="feedbackClicked.emit(carrierFeedback.noteId)"
					fxLayout="row"
					style="padding: 5px; cursor: pointer"
				>
					<td fxFlex="10">{{ DATE_MDY(carrierFeedback['created']) }}</td>
					<td fxFlex="20">{{ formatLocationData(carrierFeedback) }}</td>
					<td fxFlex="15">User: {{ getFirstName(carrierFeedback.user) || '-' }}</td>
					<td fxFlex="15">Contact: {{ getFirstName(carrierFeedback.contact) || '-' }}</td>
					<td fxFlex="25">
						<span *ngIf="utilService.isNullOrUndefined(carrierFeedback.rating)"
							>Result: {{ getResult(carrierFeedback) }}</span
						>
						<span *ngIf="!utilService.isNullOrUndefined(carrierFeedback.rating)" class="wrapper">
							<ng-rating-bar
								[(value)]="carrierFeedback.rating"
								[disabled]="true"
								[ratingCount]="5"
								class="pointer-events-none"
							>
							</ng-rating-bar>
						</span>
					</td>
					<td *ngIf="!utilService.isNullOrUndefined(carrierFeedback?.userSuggestion)" fxFlex="15">
						<mat-icon
							[matTooltip]="carrierFeedback?.userSuggestion"
							class="primary-light-color info-icon cursor-pointer"
							content-type="template"
							matTooltipClass="custom-tooltip"
							>info
						</mat-icon>
					</td>
				</div>
			</tr>
		</table>
	</div>
</div>
